import { IFullArticle } from "./article";

export const path = '/apic/helpsupport/v1/faq';
export interface IFaqItem {
  objectId: string;
  label: string;
}

export interface IBold360FaqReqParams {
  labelId?: string;
  context?: string;
  items?: number;
  days?: number;
  allContextsMandatory?: string;
}

export interface IFaqSummary {
  heading: string;
  summary?: string;
  articleId?: string;
}

export interface IFaqAPIResponse {
  faq: IFaqSummary[];
}

export interface IFaqWithArticle {
  heading: string;
  article?: IFullArticle;
}
